import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom'
import Routes from './Routes';
import ScrollIntoView from "./components/ScrollIntoView";




ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <ScrollIntoView>
        <Routes />
      </ScrollIntoView>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
);

